import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        {/* Wrap your App component with the Router */}
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);

